import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["menu", "menuLayout", "onSelect", "onClickMenuItem", "className", "useClickStatus", "clickStatusDuration", "clickSelfToClose", "touchSelfToClose", "defaultVisible", "visible", "onChange"];
import { cls } from '@arco-design/mobile-utils';
import React, { useContext, useMemo, useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { GlobalContext } from '../context-provider';
export function componentGenerator(Comp) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var menu = props.menu,
        _props$menuLayout = props.menuLayout,
        menuLayout = _props$menuLayout === void 0 ? 'vertical' : _props$menuLayout,
        onSelect = props.onSelect,
        onClickMenuItem = props.onClickMenuItem,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        _props$useClickStatus = props.useClickStatus,
        useClickStatus = _props$useClickStatus === void 0 ? false : _props$useClickStatus,
        _props$clickStatusDur = props.clickStatusDuration,
        clickStatusDuration = _props$clickStatusDur === void 0 ? 300 : _props$clickStatusDur,
        _props$clickSelfToClo = props.clickSelfToClose,
        clickSelfToClose = _props$clickSelfToClo === void 0 ? true : _props$clickSelfToClo,
        _props$touchSelfToClo = props.touchSelfToClose,
        touchSelfToClose = _props$touchSelfToClo === void 0 ? props.touchToClose === void 0 ? false : props.touchToClose : _props$touchSelfToClo,
        _props$defaultVisible = props.defaultVisible,
        defaultVisible = _props$defaultVisible === void 0 ? false : _props$defaultVisible,
        visible = props.visible,
        onChange = props.onChange,
        restProps = _objectWithoutPropertiesLoose(props, _excluded);

    var _useContext = useContext(GlobalContext),
        prefixCls = _useContext.prefixCls;

    var _useState = useState(-1),
        activeIndex = _useState[0],
        setActiveIndex = _useState[1];

    var activeTimer = useRef(0);
    var formattedMenu = useMemo(function () {
      return menu.map(function (item) {
        if (typeof item === 'string') {
          return {
            text: item
          };
        }

        return item;
      });
    }, [menu]);

    var _useState2 = useState(visible === void 0 ? defaultVisible : visible),
        visibleState = _useState2[0],
        setVisibleState = _useState2[1];

    useEffect(function () {
      setVisibleState(Boolean(visible));
    }, [visible]);
    var popoverRef = useRef(null);
    useImperativeHandle(ref, function () {
      return popoverRef.current;
    });

    var onVisibleChange = function onVisibleChange(newVisible) {
      var handleVisibleChange = function handleVisibleChange() {
        if (onChange && typeof onChange === 'function') {
          onChange(newVisible);
        }

        if (visible === void 0) {
          setVisibleState(newVisible);
        }
      }; // 如果设置了点击效果则延时回调onChange函数，留出点击效果的时间


      if (!newVisible && useClickStatus) {
        window.setTimeout(handleVisibleChange, Math.max(0, clickStatusDuration - 300));
      } else {
        handleVisibleChange();
      }
    };

    var content = useMemo(function () {
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-popover-menu-content", menuLayout + "-menu")
      }, formattedMenu.map(function (item, index) {
        var defaultValue = typeof item.text === 'string' ? item.text : "menu_item_" + index;
        var text = item.text,
            _item$value = item.value,
            value = _item$value === void 0 ? defaultValue : _item$value,
            _item$disabled = item.disabled,
            disabled = _item$disabled === void 0 ? false : _item$disabled,
            icon = item.icon;
        return /*#__PURE__*/React.createElement("div", {
          className: cls(prefixCls + "-popover-menu-item", {
            disabled: disabled,
            active: activeIndex === index
          }),
          key: value,
          onTouchStart: function onTouchStart() {
            if (useClickStatus && !disabled) {
              clearTimeout(activeTimer.current);
              setActiveIndex(index);
              activeTimer.current = window.setTimeout(function () {
                setActiveIndex(-1);
                activeTimer.current = 0;
              }, clickStatusDuration);
            }
          },
          onClick: function onClick() {
            onClickMenuItem && onClickMenuItem(value, menu[index]);
            if (disabled) return;
            onSelect && onSelect(value, menu[index]);
          }
        }, icon && /*#__PURE__*/React.createElement("div", {
          className: cls(prefixCls + "-popover-menu-icon")
        }, icon), /*#__PURE__*/React.createElement("div", {
          className: cls(prefixCls + "-popover-menu-text")
        }, text));
      }));
    }, [prefixCls, menuLayout, formattedMenu, activeIndex, useClickStatus, clickStatusDuration, onClickMenuItem, onSelect]);
    return /*#__PURE__*/React.createElement(Comp, _extends({
      ref: popoverRef,
      visible: visibleState,
      clickSelfToClose: clickSelfToClose,
      touchSelfToClose: touchSelfToClose,
      onChange: onVisibleChange
    }, restProps, {
      content: content,
      className: cls(className, prefixCls + "-popover-menu")
    }));
  });
}